import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import WelcomeSection from '../components/WelcomeSection';
import ForSaleSection from '../components/ForSaleSection';
import SoldSection from '../components/SoldSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Pam Immobilier | Courtage immobilier en Suisse romande"
        description="Votre partenaire de confiance pour l'achat et la vente de biens immobiliers en Suisse romande. Estimation personnalisée sans engagement."
      />
      <Header />
      <main>
        <HeroSection />
        <WelcomeSection />
        <ForSaleSection />
        <ServicesSection />
        <TestimonialsSection />
        <SoldSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
